export type AriaProps = {
  'aria-label'?: string;
  'aria-labelledby'?: string;
};

const ariaInterpolations = {
  ariaLabel: ({ 'aria-label': ariaLabel }: Pick<AriaProps, 'aria-label'>) =>
    ariaLabel === undefined ? {} : { ariaLabel },
  ariaLabelledBy: ({ 'aria-labelledby': ariaLabelledBy }: Pick<AriaProps, 'aria-labelledby'>) =>
    ariaLabelledBy === undefined ? {} : { ariaLabelledBy }
};

export { ariaInterpolations };
